<template>
     <div>
        <h4>{{ this.$t(this.graphTitle, { year: this.selectedYear }) }}</h4>
       <div v-if="isDataLoading" class="text-center">
         <p>{{ $t('loading') }}</p>
       </div>
       <div v-else-if="chartData.labels.length > 0">
         <line-graph
           :chart-data="chartData"
           :chart-options="chartOptions"
         />
       </div>
       <div v-else>
         <p>{{ $t('no-data-available') }}</p>
       </div>
     </div>
</template>

<script>

import LineGraph from '@/components/LineGraph';

export default {
    components: {
        LineGraph,
    },

     props: {
         selectedYear: String,
         dataByYear: Object,
         filterFunction: {
             type: Function,
             default: () => true // Default filter that includes all items
         },
         graphTitle: String,
     },

    data() {
        return {
            window_size: 3,
            colours: ['rgb(83, 140, 212)','rgb(250, 192, 142)','rgb(154, 187, 88)'],
        }
    },

    name: 'CumulativeHousingAndCommercial',

    computed: {
        isDataLoading() {
            return !this.dataByYear || Object.keys(this.dataByYear).length === 0;
        },

        windows_years() {
            if (this.isDataLoading) {
                return [];
            }
            let years = Object.keys(this.dataByYear).sort((a, b) => a - b).map(year => parseInt(year,10));
            let year = parseInt(this.selectedYear,10); 

            return (year - this.window_size > years[0]) ? 
                years.slice(years.indexOf(year - this.window_size) + 1, years.indexOf(year) + 1) : 
                years.slice(0, this.window_size);
        },

         chartData() {
             if (this.isDataLoading) {
                 return {
                     labels: [],
                     datasets: []
                 };
             }

            return {
                labels: ['January','February','March','April','May','June','July','August','September','October','November','December'],
                datasets: 
                    this.windows_years.map((year,index) => {
                        return {
                            label: this.$t('cumulative',{year: year}),
                            data: this.calculateCumulativeData(this.dataByYear[year]),
                            borderColor: this.colours[index],
                            backgroundColor: 'rgba(75, 192, 192, 0.2)',
                            tension: 0.1,
                            borderWidth: year === parseInt(this.selectedYear) ? 3 : 2,
                            font: {
                              weight: year === parseInt(this.selectedYear) ? 'bold' : 'normal'
                            },
                            pointRadius: 0
                        }
                    })
            };
        },

        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: this.$t('permit-counts')
                        }
                    },
                    x: {
                        title: {
                            display: true,
                            text: this.$t('month')
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'index',
                    intersect: false,
                },
                animation: {
                    duration: 1000,
                },
            };
        },
    },

     methods: {
         updateChart() {
             if (this.chartData && this.chartData.labels && this.chartData.labels.length > 0) {
                 this.$nextTick(() => {
                     // Call the parent renderChart method from vue-chartjs
                     this.renderChart(this.chartData, this.chartOptions);
                 });
             }
         },

         calculateCumulativeData(yearData) {
/*
Data is in this form:
{"app_start_month":"2010-01-01T00:00:00.000","category":"COMMERCIAL","sub_category":"NON-RESIDENTIAL","application_type":"ADDITION","total_count":"3"}
{"app_start_month":"2010-01-01T00:00:00.000","category":"COMMERCIAL","sub_category":"NON-RESIDENTIAL","application_type":"NEW","total_count":"14"}

*/
             // Filter the data using the provided filter function
             const filteredData = yearData.filter(this.filterFunction);
             //const filteredData = yearData;
             
             // Group and sum totals by month
             const monthlyTotals = {};
             filteredData.forEach(item => {
                 const month = new Date(item.app_start_month).getMonth();
                 if (!monthlyTotals[month]) {
                     monthlyTotals[month] = 0;
                 }
                 monthlyTotals[month] += parseInt(item.total_count);
             });

             // Initialize cumulative totals
             let runningTotal = 0;
             const cumulativeByMonth = [];
             for (let month = 0; month <= 11; month++) {
                 if (monthlyTotals[month]) {
                     runningTotal += monthlyTotals[month];
                     cumulativeByMonth.push(runningTotal);
                 }
             }

             return cumulativeByMonth;
         },

    },
}
</script>